import { DataKeyValueStringInterface } from 'pf-frontend-common/src/module/data/key-value/string.interface';
import { HttpApiResponseInterface } from 'pf-frontend-common/src/module/http/api-response.interface';
import { JsonApiPayloadInterface } from 'pf-frontend-common/src/module/json-api/payload.interface';
import { ApiServiceInterface } from 'pf-frontend-common/src/service/api/service.interface';

import { PropertyShareModel } from 'common/data/property-share/model';
import { objectFilterNonOrEmptyValue } from 'common/helper/object/filter/non-or-empty-value';
import { ApiEndpointServiceInterface } from 'common/service/api-endpoint/service.interface';

export class PropertyShareStore {
  /**
   * API endpoint
   */
  protected endpoint: { [key: string]: DataKeyValueStringInterface } = {
    create: {
      path: this.apiEndpointService.getPath('/property/{modelId}/share'),
      method: 'POST',
    },
  };

  /**
   * Constructor
   */
  constructor(protected apiService: ApiServiceInterface, protected apiEndpointService: ApiEndpointServiceInterface) {}

  /**
   * Send a property share request
   */
  public create(modelId: string, model: PropertyShareModel): Promise<HttpApiResponseInterface> {
    return new Promise((resolve, reject) => {
      // Prep path
      const path = this.endpoint.create.path.replace('{modelId}', modelId);

      // Prep payload
      const payload: JsonApiPayloadInterface = model.serialize();

      this.apiService
        .request(this.endpoint.create.method, path, objectFilterNonOrEmptyValue(payload), true)
        .then((response: HttpApiResponseInterface) => {
          // Failure
          if (response.status >= 300) {
            reject(response);

            return;
          }

          // Success!
          resolve(response);
        })
        .catch((response: HttpApiResponseInterface) => {
          // Failure
          reject(response);
        });
    });
  }
}
